exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".global-footer h1,.global-footer h2,.global-footer h3,.global-footer h4,.global-footer h5,.global-footer h6,.global-footer p{font-weight:400}.global-footer .trend-selection .content{color:#fff;padding-bottom:3em;padding-top:3em}@media (min-width:768px){.global-footer .trend-selection .content{padding-bottom:4em;padding-top:4em}}", ""]);

